/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiUserFeedbackControllerFindByIdQueryResponse, AiUserFeedbackControllerFindByIdPathParams, AiUserFeedbackControllerFindById401, AiUserFeedbackControllerFindById404 } from "../../models/aiUserFeedbackController/AiUserFeedbackControllerFindById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { aiUserFeedbackControllerFindById } from "../../clients/ai-user-feedbackService/aiUserFeedbackControllerFindById";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const aiUserFeedbackControllerFindByIdQueryKey = (id: AiUserFeedbackControllerFindByIdPathParams["id"]) => [{
  url: '/api/v1/ai-user-feedback/:id',
  params: {
    id: id
  }
}] as const;
export type AiUserFeedbackControllerFindByIdQueryKey = ReturnType<typeof aiUserFeedbackControllerFindByIdQueryKey>;
export function aiUserFeedbackControllerFindByIdQueryOptions(id: AiUserFeedbackControllerFindByIdPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = aiUserFeedbackControllerFindByIdQueryKey(id);
  return queryOptions<AiUserFeedbackControllerFindByIdQueryResponse, ResponseErrorConfig<AiUserFeedbackControllerFindById401 | AiUserFeedbackControllerFindById404>, AiUserFeedbackControllerFindByIdQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return aiUserFeedbackControllerFindById(id, config);
    }
  });
}

/**
 * @summary Get feedback by ID
 * {@link /api/v1/ai-user-feedback/:id}
 */
export function useAiUserFeedbackControllerFindById<TData = AiUserFeedbackControllerFindByIdQueryResponse, TQueryData = AiUserFeedbackControllerFindByIdQueryResponse, TQueryKey extends QueryKey = AiUserFeedbackControllerFindByIdQueryKey>(id: AiUserFeedbackControllerFindByIdPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<AiUserFeedbackControllerFindByIdQueryResponse, ResponseErrorConfig<AiUserFeedbackControllerFindById401 | AiUserFeedbackControllerFindById404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? aiUserFeedbackControllerFindByIdQueryKey(id);
  const query = useQuery({
    ...aiUserFeedbackControllerFindByIdQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AiUserFeedbackControllerFindById401 | AiUserFeedbackControllerFindById404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}